"use client";

import Cookies from "js-cookie";

interface SurveyCookieProps {
  surveyId: string;
  surveyType: string;
}

export default function SurveyCookie({
  surveyId,
  surveyType,
}: SurveyCookieProps) {
  const cookieName = surveyType + "-cookie";
  Cookies.set(cookieName, JSON.stringify({ surveyId, surveyType }), {
    expires: 1, // TODO: check back in on this setting this to expire after 1 day
    // no need for lax here, the middle ware does not need to read this cookie
    sameSite: "strict",
  });
}
